import React, { Component } from "react";
import { connect } from "react-redux";
import ScrollToBottom from "react-scroll-to-bottom";

import Message from "./Message/Message";
import styles from "./AdminPitchMessages.scss";

class AdminPitchMessages extends Component {
  constructor(props) {
    super(props);

    this.downloadAttachment = this.downloadAttachment.bind(this);
  }

  render() {
    return (
      <div className={styles.adminPitchMessages}>
        <ScrollToBottom
          scrollViewClassName={styles.adminPitchMessagesContainer}
        >
          {this.renderMessages()}
        </ScrollToBottom>
      </div>
    );
  }

  downloadAttachment(messageId) {
    if (!this.props.project.loadingMessageAttachment) {
      this.props.projectActions.downloadMessageAttachment(messageId);
    }
  }

  renderMessages() {
    const { messages, project, pitchId, memberId } = this.props;

    return (
      messages &&
      messages.map((message, key) => {
        const props = {
          downloadAttachment: this.downloadAttachment,
          loading: project.loadingMessageAttachment,
          message,
          key,
          pitchId,
          memberId,
          project
        };

        return <Message {...props} />;
      })
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.common.loading.length > 0
  };
};

export default connect(mapStateToProps)(AdminPitchMessages);



// WEBPACK FOOTER //
// ./src/routes/admin/project/messages/components/AdminPitchMessages.js